import React, { useState } from 'react';

import { useResponsive } from '@sg/garnish';

import { LocationsMap } from './components/LocationsMap';
import { useAnimatedPins, usePins, useRegion } from './hooks';
import { filterPropsByOrderType } from './utils';

import type { OrderStatusMapProps } from './types';

// ────────────────────────────────────────────────────────────────────────────────

export const OrderStatusMap = (props: OrderStatusMapProps) => {
  const { orderType, hasDeliveryAddress = true } = props;

  const [selectedPin, setSelectedPin] = useState('');

  const { match } = useResponsive();
  const filteredProps = filterPropsByOrderType(props);
  const pinCoordinates = useAnimatedPins(filteredProps);
  const animatedProps = { ...filteredProps, ...pinCoordinates };
  const computedRegion = useRegion(animatedProps);
  const pins = usePins(selectedPin, animatedProps);

  const usFallbackRegion = match([US_REGION_XS, US_REGION_SM]);
  const shouldFallbackToUsRegion = orderType === 'delivery' && !hasDeliveryAddress;
  const region = shouldFallbackToUsRegion ? usFallbackRegion : computedRegion;

  return <LocationsMap region={region} pins={pins} onPinPress={setSelectedPin} />;
};

// ─── Constants ───────────────────────────────────────────────────────────────

const US_REGION_XS = { lat: 37.0902, lng: -95.7129, zoom: 3.2 };
const US_REGION_SM = { lat: 37.0902, lng: -95.7129, zoom: 4 };
